/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';

import Axios from 'axios';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../../Context';
import Loader from '../../layout/Loader';
import Pagination from '../Pagination';
import SearchFrom from '../SearchFrom';
import Tabelrowbody from './Tabelrowbody';

import '../tabel.css';
import ExcelExport from '../ExcelExport';
import { toast } from 'react-toastify';
import ModalPrint from './ModalPrint';
import Excel from 'components/table/excel';

/**
 * این کامپوننت برای نمایش جدول در بخش نیرو است که لینک اسم نیرو به پروفایل نیرو را دارد
 */

export default function TabelWorker({
  isFromProfile,
  urldata,
  arryactions,
  isform,
  isOrderTable,
  isController,
  showform,
  handelShowForm,
  FormTabel,
  itemname,
  params,
  page,
  pageSiz,
  hiddenitem,
  tipLink,
  reload,
  reloadOff,
  reloadAvailableWorkes,
}) {
  const {
    sideBardata,
    authentication,
    setOnSearchLoding,
    urldashboard,
    idview,
    accessPage,
    handelloding,
    dataFromTabel,
    handelerrors,
    searchLoading,
    setOffSearchLoding,
  } = useContext(DashboardContext);

  const { location } = useHistory();

  const [dataFech, setDataFech] = useState({});

  const [startpage, setStartpage] = useState(
    page ? page : JSON.parse(sessionStorage.getItem('startpage')) || 1,
  );

  const [pageSize, setPageSize] = useState(
    pageSiz ? pageSiz : JSON.parse(sessionStorage.getItem('pageSize')) || 10,
  );

  const [serch, setSerch] = useState(
    JSON.parse(sessionStorage.getItem('serch')) || '',
  );
  const [deleteitem, setDeleteitem] = useState(false);

  const [loader, setLoader] = useState(true);

  const [refreshGrid, setRefreshGrid] = useState(false);

  const [inputvalue, setInputvalue] = useState('');

  const handleRefreshGridWorker = () => {
    setRefreshGrid(!refreshGrid);
  };

  const datafeching = async (startpage, pageSize, serch) => {
    let formdata = {};
    if (isform) {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        isFromProfile: isFromProfile,
        search: serch,
        ...dataFromTabel,
        [itemname]: params
          ? params
          : JSON.parse(sessionStorage.getItem('customerid'))
            ? JSON.parse(sessionStorage.getItem('customerid'))
            : idview,
      };
    } else {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        search: serch,
        isFromProfile: isFromProfile,
        ...dataFromTabel,
      };
    }

    try {
      var url = '';
      if (isController === undefined || isController) {
        url = `${urldashboard}${urldata ? urldata : location.pathname}/get`;
      } else {
        url = `${urldashboard}${urldata ? urldata : location.pathname}`;
      }
      const res = await Axios.post(url, JSON.stringify(formdata), {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });

      const data = await res.data;

      if (reloadOff !== undefined) reloadOff();

      setDataFech(data);
      setOffSearchLoding();
      setLoader(false);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    //if (isOrderTable === true)
    datafeching(startpage, pageSize, serch);
    return () => {};
  }, [
    startpage,
    pageSize,
    serch,
    deleteitem,
    dataFromTabel,
    reload,
    searchLoading,
    refreshGrid,
  ]);

  //logic serch start
  const handelserchinput = (e) => {
    if (e.target.value) {
      setInputvalue(e.target.value);
    } else {
      setInputvalue('');
      sessionStorage.setItem('serch', JSON.stringify(''));
      setSerch('');
      sessionStorage.setItem('startpage', JSON.stringify(1));
      sessionStorage.setItem('Pagination', JSON.stringify([]));
      setStartpage(1);
    }
  };
  const handelserch = (e) => {
    e.preventDefault();

    // setLoader(true)
    if (inputvalue) {
      sessionStorage.setItem('serch', JSON.stringify(inputvalue));
      setSerch(inputvalue);
      sessionStorage.setItem('startpage', JSON.stringify(1));
      sessionStorage.setItem('Pagination', JSON.stringify([]));
      setStartpage(1);
    }
    // setLoader(false)
  };
  //logic serch end

  const handeldeleteitem = () => {
    setDeleteitem(!deleteitem);
    setLoader(true);
    reloadAvailableWorkes !== undefined && reloadAvailableWorkes();
  };

  //logic Pagination start
  const handelpagenumber = (number) => {
    sessionStorage.setItem('startpage', JSON.stringify(number));
    setStartpage(number);
  };

  const handelprevpage = () => {
    if (parseInt(dataFech.page) === 1) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(startpage - 1));
      setStartpage(startpage - 1);
    }
  };

  const handelNextpage = () => {
    if (dataFech.page === dataFech.totalPage) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(startpage + 1));
      setStartpage(startpage + 1);
    }
  };
  //logic Pagination end

  const arryrowpage = [10, 20, 50, 100, 500, 1000, 2000];
  const handelrowPage = (e) => {
    setPageSize(parseInt(e.target.value));
    sessionStorage.setItem(
      'pageSize',
      JSON.stringify(parseInt(e.target.value)),
    );
    sessionStorage.setItem('startpage', JSON.stringify(1));
    sessionStorage.setItem('Pagination', JSON.stringify([]));

    setStartpage(1);
    setLoader(true);
  };

  const [print, setPrint] = useState([]);

  const [lodingPrint, setlodingPrint] = useState(false);

  const [allprint, setAllprint] = useState(false);

  const handelPrint = (event) => {
    if (event.target.checked) {
      setPrint([...print, event.target.value]);
    } else {
      const isold = print.filter((find) => find !== event.target.value);
      setPrint(isold);
    }
  };

  // modalPrint

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [dataPrint, setDataPrint] = useState([]);

  const handelCloseModalPrint = () => setShowPrintModal(false);

  // const handelprint = (data) => {
  //     const oldbody = document.body.innerHTML;

  //     const body = data.map(item => <Print data={item} />)

  //     const newbody = `<div>${body}</div>`;

  //     document.body.innerHTML = newbody

  //     window.print();

  //     document.body.innerHTML = oldbody;
  //     // const body = document.getElementById('bodyPrint').innerHTML;

  //     // const win = window.open();

  //     // win.document.write(body)

  // }

  // EndModalPrin

  const handelsendPrint = async () => {
    setlodingPrint(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/order/print`,
        JSON.stringify({ orderScheduleIds: print }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );

      const data = await res.data.data;
      setlodingPrint(false);
      setDataPrint(data);
      setShowPrintModal(true);
    } catch (error) {
      handelerrors(error);
      setlodingPrint(false);
    }
  };

  const [smsarry, setsmsarry] = useState([]);

  const [startworkarry, setstartworkarry] = useState([]);

  const [lodingStartWork, setlodingStartWork] = useState(false);
  const [enableStartWork, setEnableStartWork] = useState(false);
  const [allStartWorkCheck, setAllStartWorkCheck] = useState(false);

  const [lodingSms, setLodingSms] = useState(false);

  const [allSmsCheck, setAllSmsCheck] = useState(false);

  const handelSms = (event) => {
    if (event.target.checked) {
      setsmsarry([...smsarry, event.target.value]);
    } else {
      const isold = smsarry.filter((find) => find !== event.target.value);

      setsmsarry(isold);
    }
  };

  const handelStartWork = (event) => {
    if (event.target.checked) {
      setstartworkarry([...startworkarry, event.target.value]);
    } else {
      const isold = startworkarry.filter((find) => find !== event.target.value);

      setstartworkarry(isold);
    }
  };

  const handelSubmitStartWork = async () => {
    setlodingStartWork(true);

    try {
      const res = await Axios.post(
        `${urldashboard}/workerorderschedule/groupStartWork`,
        JSON.stringify({ workerOrderScheduleIds: startworkarry }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );
      //reload();
      setlodingStartWork(false);
      datafeching(startpage, pageSize, serch);
      toast.success(res.data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      handelerrors(error);
      setlodingStartWork(false);
    }
  };

  const handelSendSms = async () => {
    setLodingSms(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/order/sendcustomersms`,
        JSON.stringify({ orderScheduleIds: smsarry }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );
      const data = await res.data;
      setLodingSms(false);
      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      handelerrors(error);
      setLodingSms(false);
    }
  };

  const [userarry, setUserarry] = useState([]);

  const [lodinguser, setLodinguser] = useState(false);

  const [allUseSelect, setAllUseSelect] = useState(false);

  const handeluser = (event) => {
    if (event.target.checked) {
      setUserarry([...userarry, event.target.value]);
    } else {
      const isold = userarry.filter((find) => find !== event.target.value);

      setUserarry(isold);
    }
  };

  const handeluserSend = async () => {
    setLodinguser(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/order/sendworkersms`,
        JSON.stringify({ orderScheduleIds: userarry }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );

      const data = await res.data;
      setLodinguser(false);
      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      handelerrors(error);
      setLodinguser(false);
    }
  };

  const handelAllCheckBox = (itemname) => {
    let itemarry = [];

    [...document.querySelectorAll(`.${itemname}`)].map((item) => {
      if (itemname === 'printCheckbox') {
        if (!allprint) {
          item.checked = true;
          itemarry.push(item.value);
        } else {
          item.checked = false;
          itemarry = [];
        }
      } else if (itemname === 'smscheckbox') {
        if (!allSmsCheck) {
          item.checked = true;
          itemarry.push(item.value);
        } else {
          item.checked = false;
          itemarry = [];
        }
      } else if (itemname === 'startworkCheckbox') {
        setEnableStartWork(!enableStartWork);

        if (!allStartWorkCheck) {
          item.checked = true;
          itemarry.push(item.value);
        } else {
          item.checked = false;
          itemarry = [];
        }
      } else {
        if (!allUseSelect) {
          item.checked = true;
          itemarry.push(item.value);
        } else {
          item.checked = false;
          itemarry = [];
        }
      }
    });
    if (itemname === 'printCheckbox') {
      setAllprint(!allprint);
      setPrint(itemarry);
    } else if (itemname === 'smscheckbox') {
      setsmsarry(itemarry);
      setAllSmsCheck(!allSmsCheck);
    } else if (itemname === 'startworkCheckbox') {
      setstartworkarry(itemarry);
      setAllStartWorkCheck(!allStartWorkCheck);
    } else {
      setUserarry(itemarry);
      setAllUseSelect(!allUseSelect);
    }
  };

  return (
    <>
      {sideBardata.length > 0 ? (
        <>
          <Row className='mb-3 mt-3'>
            <SearchFrom
              handelserchinput={handelserchinput}
              handelserch={handelserch}
            />

            <Col md={6} sm={6} xs={12} className='d-flex  justify-content-end'>
              {location.pathname === '/WorkerOrderSchedule' ? (
                <Button
                  onClick={handelSubmitStartWork}
                  className='m-1'
                  variant='primary'
                  disabled={
                    enableStartWork
                      ? false
                      : startworkarry.length > 0
                        ? false
                        : true
                  }
                >
                  {lodingStartWork ? (
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>
                  ) : (
                    <i className='mdi mdi-cloud-print-outline'></i>
                  )}
                </Button>
              ) : null}
              {showform ? (
                <button
                  className='btn btn-success ml-3'
                  onClick={handelShowForm}
                >
                  {FormTabel ? 'بستن فرم' : 'جستجوی پیشرفته'}
                </button>
              ) : null}
              <div className='mt-sm-0 mt-lg-0 mt-3'>
                {dataFech.hasOwnProperty('data') ? (
                  <>
                    {hiddenitem ? null : arryactions ? (
                      arryactions.includes('Print') ? (
                        <Button
                          onClick={handelsendPrint}
                          className='m-1'
                          variant='primary'
                          disabled={
                            lodingPrint ? true : print.length > 0 ? false : true
                          }
                        >
                          {lodingPrint ? (
                            <i className='fa fa-spinner fa-pulse fa-fw'></i>
                          ) : (
                            <i className='mdi mdi-cloud-print-outline'></i>
                          )}
                        </Button>
                      ) : null
                    ) : accessPage.includes('Print') ? (
                      <Button
                        onClick={handelsendPrint}
                        className='m-1'
                        variant='primary'
                        disabled={
                          lodingPrint ? true : print.length > 0 ? false : true
                        }
                      >
                        {lodingPrint ? (
                          <i className='fa fa-spinner fa-pulse fa-fw'></i>
                        ) : (
                          <i className='mdi mdi-cloud-print-outline'></i>
                        )}
                      </Button>
                    ) : null}

                    {hiddenitem ? null : arryactions ? (
                      arryactions.includes('SendWorkerSms') ? (
                        <Button
                          onClick={handelSendSms}
                          className='m-1'
                          variant='primary'
                          disabled={
                            lodingSms ? true : smsarry.length > 0 ? false : true
                          }
                        >
                          {lodingSms ? (
                            <i className='fa fa-spinner fa-pulse fa-fw'></i>
                          ) : (
                            <i className='mdi mdi-comment-multiple-outline'></i>
                          )}
                        </Button>
                      ) : null
                    ) : accessPage.includes('SendWorkerSms') ? (
                      <Button
                        onClick={handelSendSms}
                        className='m-1'
                        variant='primary'
                        disabled={
                          lodingSms ? true : smsarry.length > 0 ? false : true
                        }
                      >
                        {lodingSms ? (
                          <i className='fa fa-spinner fa-pulse fa-fw'></i>
                        ) : (
                          <i className='mdi mdi-comment-multiple-outline'></i>
                        )}
                      </Button>
                    ) : null}
                    {hiddenitem ? null : arryactions ? (
                      arryactions.includes('SendCustomerSms') ? (
                        <Button
                          onClick={handeluserSend}
                          className='m-1'
                          variant='primary'
                          disabled={
                            lodinguser
                              ? true
                              : userarry.length > 0
                                ? false
                                : true
                          }
                        >
                          {lodinguser ? (
                            <i className='fa fa-spinner fa-pulse fa-fw'></i>
                          ) : (
                            <i className='mdi mdi-account-multiple-outline'></i>
                          )}
                        </Button>
                      ) : null
                    ) : accessPage.includes('SendCustomerSms') ? (
                      <Button
                        onClick={handeluserSend}
                        className='m-1'
                        variant='primary'
                        disabled={
                          lodinguser ? true : userarry.length > 0 ? false : true
                        }
                      >
                        {lodinguser ? (
                          <i className='fa fa-spinner fa-pulse fa-fw'></i>
                        ) : (
                          <i className='mdi mdi-account-multiple-outline'></i>
                        )}
                      </Button>
                    ) : null}
                  </>
                ) : null}

                {dataFech.hasOwnProperty('data') ? (
                  location.pathname === '/WorkerOrderSchedule' ||
                  location.pathname === '/Order' ||
                  location.pathname === '/BusinessToBusinessOrder' ? (
                    <Excel
                      server
                      fileName={'کارهای_نیروها'}
                      url={'/workerOrderSchedule/getExcel'}
                      props={
                        location.pathname === '/WorkerOrderSchedule'
                          ? {
                              ...dataFromTabel,
                              page: startpage,
                              pageSize,
                            }
                          : {
                              search: serch,
                              ...dataFromTabel,
                              [itemname]: params
                                ? params
                                : JSON.parse(
                                      sessionStorage.getItem('customerid'),
                                    )
                                  ? JSON.parse(
                                      sessionStorage.getItem('customerid'),
                                    )
                                  : idview,
                              page: startpage,
                              pageSize,
                            }
                      }
                    />
                  ) : (
                    <ExcelExport
                      data={dataFech.data}
                      headers={dataFech.headers.map((item) => item.label)}
                      filename={location.pathname.slice(
                        1,
                        location.pathname.length,
                      )}
                    />
                  )
                ) : null}
              </div>
            </Col>
          </Row>
          {!loader ? (
            dataFech.data.length > 0 ? (
              <>
                <div className='table-responsive tabeldata'>
                  <Table hover bordered>
                    <thead>
                      <tr>
                        <th>ردیف</th>

                        <th>#</th>
                        {location.pathname ===
                          '/BusinessToBusinessCanceledOrder' && (
                          <th>خوانده شده</th>
                        )}
                        {hiddenitem ? null : location.pathname ===
                          '/WorkerOrderSchedule' ? (
                          <>
                            {' '}
                            <th
                              onClick={() =>
                                handelAllCheckBox('startworkCheckbox')
                              }
                            >
                              <i className='mdi mdi-account-multiple-outline'></i>
                            </th>
                          </>
                        ) : location.pathname ===
                          '/WorkerOrderSchedule' ? null : urldata ===
                          '/WorkerOrderSchedule' ? null : (
                          <>
                            <th
                              onClick={() => handelAllCheckBox('printCheckbox')}
                            >
                              <i className='mdi mdi-cloud-print-outline'></i>
                            </th>
                            <th
                              onClick={() => handelAllCheckBox('smscheckbox')}
                            >
                              <i className='mdi mdi-comment-multiple-outline'></i>
                            </th>
                            <th
                              onClick={() => handelAllCheckBox('userCheckbox')}
                            >
                              <i className='mdi mdi-account-multiple-outline'></i>
                            </th>
                          </>
                        )}
                        {dataFech.headers.length > 0 ? (
                          location.pathname === '/WorkerOrderSchedule' ? (
                            dataFech.headers
                              .slice(2, 13)
                              .map((item) =>
                                item.name === 'id' ? (
                                  <th key={item.name}>ردیف</th>
                                ) : (
                                  <th key={item.name}>{item.label}</th>
                                ),
                              )
                          ) : urldata === '/WorkerOrderSchedule' ? (
                            <>
                              {dataFech.headers.slice(2, 13).map((item) => (
                                <th key={item.name}>{item.label}</th>
                              ))}
                              <th>نیروی معرفی‌کننده</th>
                            </>
                          ) : location.pathname === '/PeriodOrder' ? (
                            dataFech.headers
                              .slice(2, 13)
                              .map((item) =>
                                item.name === 'id' ? (
                                  <th key={item.name}>ردیف</th>
                                ) : (
                                  <th key={item.name}>{item.label}</th>
                                ),
                              )
                          ) : urldata === '/PeriodOrder' ? (
                            dataFech.headers
                              .slice(2, 13)
                              .map((item) =>
                                item.name === 'id' ? (
                                  <th key={item.name}>ردیف</th>
                                ) : (
                                  <th key={item.name}>{item.label}</th>
                                ),
                              )
                          ) : (
                            <>
                              {dataFech.headers
                                .slice(4, 13)
                                .map((item) =>
                                  item.name === 'id' ? (
                                    <th key={item.name}>ردیف</th>
                                  ) : (
                                    <th key={item.name}>{item.label}</th>
                                  ),
                                )}
                              <th>نیروی مورد نیاز</th>
                            </>
                          )
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {dataFech.data.map((item, index) => {
                        return (
                          <Tabelrowbody
                            // arryheder={dataFech.headers.length > 13 ? urldata === '/WorkerOrderSchedule' ? dataFech.headers.slice(13, dataFech.headers.length) : location.pathname === '/WorkerOrderSchedule' ? dataFech.headers.slice(13, dataFech.headers.length) : dataFech.headers.slice(13, dataFech.headers.length) : []}
                            arryheder={
                              dataFech.headers.length > 0
                                ? dataFech.headers.slice(
                                    5,
                                    dataFech.headers.length,
                                  )
                                : []
                            }
                            page={startpage}
                            key={item.id}
                            item={item}
                            number={index}
                            hiddenitem={hiddenitem}
                            refreshGridWorker={handleRefreshGridWorker}
                            tipLink={tipLink}
                            urldata={urldata}
                            deleteitem={deleteitem}
                            handeldeleteitem={handeldeleteitem}
                            arryactions={arryactions}
                            handelPrint={handelPrint}
                            handelSms={handelSms}
                            handlestartwork={handelStartWork}
                            handeluser={handeluser}
                          />
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className='mt-3 mb-5'>
                  <Col
                    md={5}
                    sm={6}
                    xs={12}
                    className='d-flex align-items-baseline'
                  >
                    <Pagination
                      totalPage={dataFech.totalPage}
                      page={dataFech.page}
                      handelprevpage={handelprevpage}
                      handelNextpage={handelNextpage}
                      handelpagenumber={handelpagenumber}
                    />
                  </Col>
                  <Col
                    md={4}
                    sm={3}
                    xs={6}
                    className='d-flex align-items-end d-sm-block mt-sm-2'
                  >
                    <div className='d-flex ml-auto mr-sm-auto '>
                      <p>مجموع کل : </p>
                      <span className='mr-2'> {dataFech.totalRecord} </span>
                    </div>
                  </Col>
                  <Col md={3} sm={3} xs={6} className='mt-sm-0 mt-3 mt-md-0'>
                    <div className='rowminger'>
                      <p className='text-nowrap'>تعداد ردیف :</p>
                      <Form.Control
                        size='sm'
                        as='select'
                        onChange={handelrowPage}
                      >
                        {arryrowpage.map((item) => (
                          <option
                            key={item}
                            selected={item === pageSize ? true : false}
                            value={item}
                          >
                            {item}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              ' چیزی یافت نشد :('
            )
          ) : (
            <Loader />
          )}
        </>
      ) : (
        <Loader />
      )}
      <ModalPrint
        showmodal={showPrintModal}
        colseModal={handelCloseModalPrint}
        dataPrint={dataPrint}
      />
    </>
  );
}
